import * as ko from "knockout";
import Bao from "./../../../services/bao-service";
// bao migrate - module not found: import "services/bao-template-engine";
import "./../../../bindings/bao-date-time-box";
import "./../../../bindings/bao-searcher";
function ExpandedSearchChecklist(parent) {
    var self = this;
    var htmlUrl = "Checkware/CheckwareExpandedSearch/ExpandedChecklist";
    self.SearchModel = parent;
    self.DeletetTemplates = ko.observable();
    self.CustomFilter = ko.computed(function () {
        if (self.DeletetTemplates != null) {
            if (!self.DeletetTemplates()) {
                return null;
            }
            else {
                return {
                    DeletetTemplates: self.DeletetTemplates()
                };
            }
        }
    });
    self.CustomFilter.subscribe(function () {
        parent.CustomFilter(self.CustomFilter());
    });
    self.LoadHtml = function () {
        return Bao.get(htmlUrl, function (result) {
            Bao.Templates[htmlUrl] = result;
            parent.ExpandedSearchTemplateName(htmlUrl);
        });
    };
    self.init = function () {
        return self.LoadHtml();
    };
}
export default ExpandedSearchChecklist;